// extracted by mini-css-extract-plugin
export default {"promo_balance":"PromoBalance_promo_balance__2IgIG","saleLabel":"PromoBalance_saleLabel__kvjgn"};